export default [
  {
    title: 'Centre de Support',
    route: 'supplier-support-center',
    icon: 'HeadphonesIcon',
  },
  {
    title: 'Tableau de bord',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Rechercher un colis',
    icon: 'SearchIcon',
    route: 'orders-search-history',
  },
  {
    title: 'Création rapide',
    route: 'order-quick-add',
    icon: 'ZapIcon',
  },
  {
    title: 'Ajouter un colis',
    route: 'order-add',
    icon: 'PlusCircleIcon',
  },
  {
    title: 'Liste des colis',
    route: 'orders-index',
    icon: 'PackageIcon',
  },
  {
    title: 'Bordereau',
    route: 'delivery-note-list',
    icon: 'FileTextIcon',
  },
  {
    title: 'Liste des pickups',
    route: 'pickup-list',
    icon: 'TruckIcon',
  },
  {
    title: 'Créer un pickup',
    route: { name: 'pickup-add' },
    icon: 'ShoppingCartIcon',
  },
  {
    title: 'Liste des règlements',
    icon: 'CreditCardIcon',
    route: 'invoice-list',
  },
  {
    title: 'Bon de retour',
    icon: 'RotateCcwIcon',
    route: 'bon-retour-list',
  },
  {
    title: "Manifestes d'échange",
    icon: 'ClipboardIcon',
    route: 'exchange-manifest-list',
  },
  {
    title: 'Support',
    icon: 'mdi-lifebuoy',
    children: [
      {
        title: 'Tickets de support',
        icon: 'HelpCircleIcon',
        route: 'SupportTicketList',
      },
      {
        title: 'Demandes de nouvelle livraison',
        icon: 'RefreshCwIcon',
        route: 'RedeliveryRequestList',
      },
      {
        title: 'Demandes de modification de prix',
        icon: 'DollarSignIcon',
        route: 'PriceChangeRequestList',
      },
    ],
  },
  {
    title: 'Mon Portefeuille',
    route: 'my-wallet',
    icon: 'CreditCardIcon',
  },
]
